<records-image-content-block imgSrc="../../assets/woman.svg" imgAlign="left">
  <h2>{{ 'SECURITY.TITLE' | translate }}</h2>
  <records-text-block 
    *ngFor="let item of 'SECURITY.LIST' | translate | keyvalue"
    title="{{item.value.TITLE}}"
    text="{{item.value.TEXT}}"
    [img]="'../../assets/' + item.value.IMAGE"></records-text-block>
</records-image-content-block>